import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, useCallback, useMemo, useState } from 'react';

interface Props {
  canTrade: boolean;
  className?: string;
  id: string;
  e2e: string;
  tradeLabelKey: IntlKey;
  onCancel(): void;
  onTrade(): void;
}

export const TradeButtonsComponent: FC<Props> = ({ canTrade, onTrade, onCancel, id, tradeLabelKey, e2e }) => {
  const [hasExecuted, setHasExecuted] = useState(false);
  const onTradeClick = useCallback(() => {
    setHasExecuted(true);
    onTrade();
  }, [onTrade]);
  const isTradeDisabled = useMemo(() => !canTrade || hasExecuted, [hasExecuted, canTrade]);
  return (
    <div className="my-2">
      <button
        className="btn btn-xl w-100 btn-info my-1"
        data-e2e={e2e}
        disabled={isTradeDisabled}
        id={id}
        onClick={onTradeClick}
        type="button"
      >
        <FormattedMessage id={tradeLabelKey} />
      </button>

      <button
        className="btn btn-xl w-100 me-1 btn-light my-1"
        data-e2e="cancel-trade"
        id="btn-cancel-trade"
        onClick={onCancel}
        type="button"
      >
        <FormattedMessage id="form.buttons.Cancel" />
      </button>
    </div>
  );
};

TradeButtonsComponent.displayName = 'TradeButtonsComponent';
